import React, { useContext } from 'react'
import Layout from '../components/Layout'
import TextField from '@material-ui/core/TextField'
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import EmployeeFormStep2 from '../components/Forms/Employee/EmployeeFormStep2'
import HeaderWithSideBar from '../components/HeaderWithSideBar'
import ProfilePic from '../../src/assets/images/Profile.PNG'
import { useFeatures } from '../../src/hooks/Features/useFeatures'
import { useCompanyAdmin } from '../../src/hooks/CompanyAdmin/useCompanyAdmin'
import CustomSelect from '../components/CustomSelect'
import CustomDatePicker from '../components/CustomDatePicker'
import CustomTimePicker from '../components/CutomTimePicker'
import CustomInput from '../components/CustomInput'
import CustomImage from '../components/CustomImage'
import EmployeeForm1 from '../components/Forms/Employee/EmployeeForm1'
import ActionButton from '../components/ActionButton'
import { useLocation } from '../hooks/Location/useLocation'
import EmployeeFormStep4 from '../components/Forms/Employee/EmployeeFormStep4'
import { ROUTES } from '../shared/constants'
import EditIcon from '@material-ui/icons/Edit'
import { Box, IconButton, makeStyles, Tabs, Tab, StepLabel, Stepper, Typography, Grid, Select, MenuItem, FormControlLabel, Checkbox } from '@material-ui/core'
import { useHistory } from 'react-router'
import { UserContext } from '../context api/UserContext'
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#EFF3FE',
    borderRadius: '10px',
    marginTop: '10px',
    // margin: '10px 30px 10px 0px',
  },
  tab: {
    textTransform: 'none',
    fontFamily: 'Open sans',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '20px',
  },
  tabs: {
    '& > span': {
      maxWidth: '50px',
      width: '100%',
    },
    input: {
      '&:focus': {
        outline: 'none',
      },
    },
  },
}))

function ThreetabsLayout({ tab1, tab2, tab3, content1, content2, content3, addcontent1, addcontent2, addcontent3, submit, view, editUrl }) {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)
  const history = useHistory()
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const user = useContext(UserContext)
  const userType = user && user.user && user.user.userType === 'COMPANYADMIN'
  function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
      <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    )
  }
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const addContentFirst = () => {
    addcontent1()
    setValue(1)
  }
  const addContentSecond = () => {
    addcontent2()
    setValue(2)
  }
  const addContentThird = () => {
    addcontent3()
    setValue(3)
  }

  // //console.log(
  //   tab1,
  //   tab2,
  //   tab3,
  //   content1,
  //   content2,
  //   content3,

  //   submit,
  //   view,
  //   editUrl
  // )
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} lg={12} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #CCCCCC' }}>
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" className={classes.tabs}>
          <Tab
            label={tab1}
            {...a11yProps(0)}
            className={classes.tab}
            //   disabled={value === 1 || value === 2 ? true : false}
          />
          <Tab
            label={tab2}
            {...a11yProps(1)}
            className={classes.tab}
            //   disabled={!added || value === 2 ? true : false}
          />
          <Tab
            label={tab3}
            {...a11yProps(2)}
            className={classes.tab}
            //   disabled={value === 0 || value === 1 ? true : false}
          />
        </Tabs>
        {view && userType && (
          <div
            style={{
              border: '1px solid #CCCCCC',
              width: '30px',
              height: '30px',
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              borderRadius: '5px',
              marginTop: '10px',
              marginRight: '10px',
              paddingTop: '2px',
            }}
          >
            <EditIcon
              onClick={() => history.push(editUrl)}
              style={{
                cursor: 'pointer',
              }}
            />
          </div>
        )}
      </Grid>
      <Grid item lg={12}>
        <TabPanel value={value} index={0} style={{ maxWidth: '100%' }}>
          {content1}
        </TabPanel>
      </Grid>

      <Grid item lg={12}>
        <TabPanel value={value} index={1}>
          {content2}
        </TabPanel>
      </Grid>
      <Grid item lg={12}>
        <TabPanel value={value} index={2}>
          {content3}
        </TabPanel>
      </Grid>

      {submit && <ActionButton handleSubmit={value === 0 ? addContentFirst : value === 1 ? addContentSecond : addContentThird} />}
    </Grid>
  )
}

export default ThreetabsLayout
